
export type UpdateUserBody = {
  /** 이메일 주소 */
  email?: string;
  /** 전체 이름 */
  fullName?: string;
  /** 프로필 이미지 URL */
  profileImageUrl?: string;
};
